import PostEditForm from "components/posts/PostEditForm";

export default function PostEdit() {
    return <PostEditForm />;
}
